import { useContext } from 'react';
import PortfolioItemContext from '../../../PortfolioItemContext';
import ShouldGetImagesFromPublicApiContext from '@/components/FileAttachments/ShouldGetImagesFromPublicApiContext';
import useGlobalStaticApiResponse from '@/lib/api/useGlobalStaticApiResponse';
import useImageAsDataUrl from '@/lib/utils/useImageAsDataUrl';
import shouldShowInappropriateContentIndicators from '@/lib/files/shouldShowInappropriateContentIndicators';
import ThumbnailBannerInappropriateContentOverlay from './ThumbnailBannerInappropriateContentOverlay';
import ThumbnailBannerLoadingState from './ThumbnailBannerLoadingState';
import StyledThumbnailImage from './StyledThumbnailImage';

const ThumbnailBannerImage = () => {
  const { portfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const shouldGetImagesFromPublicApi = useContext(
    ShouldGetImagesFromPublicApiContext,
  );

  const [loading, imageBlob] = useGlobalStaticApiResponse<Blob>(
    `${portfolioItemApiEndpoint}/thumbnail/${portfolioItem.thumbnail!.id}${shouldGetImagesFromPublicApi ? '/public' : ''}`,
  );
  const imageAsDataUrl = useImageAsDataUrl(
    portfolioItem.thumbnail!.file.storageFilename,
    imageBlob,
  );

  if (loading || imageAsDataUrl === null) {
    return <ThumbnailBannerLoadingState />;
  }

  const showInappropriateContentIndicators =
    shouldShowInappropriateContentIndicators(portfolioItem.thumbnail!);

  return (
    <>
      <StyledThumbnailImage src={imageAsDataUrl} />
      {showInappropriateContentIndicators && (
        <ThumbnailBannerInappropriateContentOverlay />
      )}
    </>
  );
};

export default ThumbnailBannerImage;
